import type { JSX, ReactNode } from 'react';
import { ErrorBoundary } from './ErrorBoundary';
import { triggerGlobalError } from './ErrorContext';

interface GlobalErrorBoundaryProps {
  readonly children: ReactNode;
}

/**
 * The single app-wide boundary — mounted once at the root (src/index.tsx). The
 * boundary itself builds and sends the error-log payload; this only mirrors it into
 * ErrorContext so the redirect page's dev-mode stack display keeps working.
 */
function GlobalErrorBoundary({ children }: GlobalErrorBoundaryProps): JSX.Element {
  return (
    <ErrorBoundary
      isAppRoot
      name="app"
      mode="redirect"
      onError={(error, payload) => triggerGlobalError(error, payload.stack)}
    >
      {children}
    </ErrorBoundary>
  );
}

export default GlobalErrorBoundary;
